/* unplugin-vue-components disabled */import { render } from "./thresholdAlarm.vue?vue&type=template&id=72ef5d76&scoped=true"
import script from "./thresholdAlarm.vue?vue&type=script&lang=js"
export * from "./thresholdAlarm.vue?vue&type=script&lang=js"

import "./thresholdAlarm.vue?vue&type=style&index=0&id=72ef5d76&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\北国之春\\north\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ef5d76"]])

export default __exports__